import { getTranslatedString } from 'helpers/i18n';

export const applicantsWithoutContactMethod = (application) => {
  return application.cotenants.filter((a) => !a.contact_methods.length);
};

export const namesWithoutContactMethod = (application) => {
  return applicantsWithoutContactMethod(application)
    .map((a) => a.full_name)
    .join(', ');
};

export const missingContactsText = (application) => {
  return getTranslatedString(
    `landlordPortal.applicationManagement.applicationOverview.MissingContacts.modal.text`,
    { applicantNames: namesWithoutContactMethod(application) }
  );
};

export const missingContactsTitle = getTranslatedString(
  `landlordPortal.applicationManagement.applicationOverview.MissingContacts.modal.title`
);
